/** VBoxContainer registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseVBoxContainer } from './parser';
const vBoxContainerRegistration = {
    typeName: 'VBoxContainer',
    parser: parseVBoxContainer,
};
nodeRegistry.register(vBoxContainerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map